import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class LocalPickup extends Component {
  /** @type {AbortController | undefined} */
  #activeFetch;

  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest(`.shopify-section, dialog`);

    const variantUpdated = (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productUrl = event.detail.data.newProduct.url;
      }

      const variantId = event.detail.resource ? event.detail.resource.id : null;
      const variantAvailable = event.detail.resource ? event.detail.resource.available : null;
      if (variantId !== this.dataset.variantId) {
        if (variantId && variantAvailable) {
          this.removeAttribute('hidden');
          this.dataset.variantId = variantId;
          this.#fetchAvailability(variantId);
        } else {
          this.setAttribute('hidden', '');
        }
      }
    };

    closestSection?.addEventListener(ThemeEvents.variantUpdate, variantUpdated);

    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(ThemeEvents.variantUpdate, variantUpdated);
    };
  }

  #createAbortController() {
    if (this.#activeFetch) this.#activeFetch.abort();
    this.#activeFetch = new AbortController();
    return this.#activeFetch;
  }

  #fetchAvailability = (variantId) => {
    if (!variantId) return;

    const abortController = this.#createAbortController();
    const url = this.dataset.productUrl;

    const htmlFetch = fetch(`${url}?variant=${variantId}&section_id=${this.dataset.sectionId}`, {
      signal: abortController.signal,
    }).then((r) => r.text());

    const inventoryFetch = fetch(`${url}.js`, {
      signal: abortController.signal,
    }).then((r) => r.json()).catch(() => null);

    Promise.all([htmlFetch, inventoryFetch]).then(([text, productData]) => {
      if (abortController.signal.aborted) return;

      const html = new DOMParser().parseFromString(text, 'text/html');
      const wrapper = html.querySelector(`local-pickup[data-variant-id="${variantId}"]`);
      if (wrapper) {
        this.removeAttribute('hidden');
        morph(this, wrapper);

        // Construir mapa de disponibilidad por ubicación desde el variant
        if (productData?.variants) {
          const variant = productData.variants.find(v => String(v.id) === String(variantId));
          if (variant) {
            this.querySelectorAll('.pickup-availability__location-item').forEach(el => {
              const name = el.querySelector('.pickup-location__text-bold')?.textContent?.trim();
              // Si el variant no tiene stock, ocultar todas
              if (!variant.available) {
                el.style.display = 'none';
              }
            });
          }
        }
      } else {
        this.setAttribute('hidden', '');
      }
    }).catch((_e) => {
      if (abortController.signal.aborted) return;
      this.setAttribute('hidden', '');
    });
  };
}

if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}